import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { countryNationalityActions } from '../../../application/actions/countryNationality';

import api from '../../api';

const apiCountryNationality = api(process.env.REACT_APP_COUNTRY_NATIONALITY_API);

export function* fetchCountryNationality() {
  try {
    const { data } = yield call(apiCountryNationality.get, 'v1/consultar');

    if (data)
      yield put(
        countryNationalityActions.fetchCountryNationalitySuccess({ countryNationality: data.paises })
      );
    else yield put(countryNationalityActions.fetchCountryNationalityError());
  } catch (err) {
    yield put(countryNationalityActions.fetchCountryNationalityError());
  }
}

export function* watchFetchCountryNationality() {
  yield takeLatest(countryNationalityActions.fetchCountryNationality.type, fetchCountryNationality);
}

export default function* countryNationalitySaga() {
  yield spawn(watchFetchCountryNationality);
}
